export default "__VITE_ASSET__$IheeB04__"